import { Injectable } from '@angular/core';
import { UpdateMetaPayloadProps } from '@boxx/onboarding-core';
import { Store } from '@ngrx/store';
import { IWizardCreateUserPayloadProps } from '../../repositories/IOnboarding.api';
import * as fromOnboardingActions from '../onboarding.actions';
import * as fromRegistrationActions from '../onboarding.actions';
import * as fromReducer from './registration.reducer';
import * as fromRegistrationSelectors from './registration.selectors';

@Injectable()
export class OnboardingRegistrationStore {
  constructor(public store: Store<fromReducer.IOnboardingRegistrationState>) {}

  // ----------- REGISTRATION METHODS: ---------------------
  get state$() {
    return this.store.select(fromRegistrationSelectors.getRegistrationState);
  }

  //// USER DATA:
  createUser = (payload: IWizardCreateUserPayloadProps) => {
    this.store.dispatch(
      fromRegistrationActions.createUserBeginAction({ payload })
    );
  };
  get registrationUserState$() {
    return this.store.select(
      fromRegistrationSelectors.getRegistrationUserState
    );
  }
  get registrationUserData$() {
    return this.store.select(fromRegistrationSelectors.getRegistrationUserData);
  }
  get registrationUserIsLoading$() {
    return this.store.select(
      fromRegistrationSelectors.getRegistrationUserIsLoading
    );
  }
  get registrationUserSuccess$() {
    return this.store.select(
      fromRegistrationSelectors.getRegistrationUserSuccess
    );
  }
  get registrationUserError$() {
    return this.store.select(
      fromRegistrationSelectors.getRegistrationUserError
    );
  }

  updateMeta = (payload: UpdateMetaPayloadProps) => {
    this.store.dispatch(
      fromOnboardingActions.updateMetaBeginAction({ payload })
    );
  };
}
